import { render, staticRenderFns } from "./AdminDashboardView.vue?vue&type=template&id=09085c47&scoped=true&"
import script from "./AdminDashboardView.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./AdminDashboardView.vue?vue&type=style&index=0&id=09085c47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09085c47",
  null
  
)

export default component.exports